import React, { useState, useEffect } from "react";
import DynamicDropdown from "./DynamicDropdown/DynamicDropdown";
import { Calendar } from "lucide-react";
import "./styles/BillingHeader.css";
import moment from "moment-hijri";

const BillingHeader = ({ onMasterDataChange }) => {
  const [invoiceNo, setInvoiceNo] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);
  const currentHijriDate = moment().format("iYYYY/iM/iD");
  const [hijriDate, setHijriDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  useEffect(() => {
    const fetchInvoiceNo = async () => {
      try {
        const response = await fetch("http://127.0.0.1:5000/api/getNextInvoiceNo");
        const data = await response.json();
        setInvoiceNo(data.invoiceNo);
      } catch (error) {
        console.error("Error fetching invoice number:", error);
      }
    };
    fetchInvoiceNo();
  }, []);

  const handleCustomerChange = async (selected) => {
    setSelectedCustomer(selected);
    if (selected?.value) {
      try {
        const response = await fetch(
          `http://127.0.0.1:5000/api/customers/${selected.value}`
        );
        const customerData = await response.json();
        setCustomerDetails(customerData);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    } else {
      setCustomerDetails(null);
    }
  };

  return (
    <header className="billing-header">
      
      {/* Company Brand Bar */}
      <div className="brand-bar">
        <div className="company-brand">
          <div className="company-logo">
            <img src="/path-to-your-logo.png" alt="" />
          </div>
          <div className="company-info">
            <h1  >ABC corp.</h1>
            
            <span>Purchase Invoice</span>
            <span>
              <div className="form-group">
                <label>Invoice No:</label>
                <span class="badge rounded-pill bg-secondary">{invoiceNo}</span>
                <label>Date:</label>
                <span class="badge rounded-pill bg-secondary">{currentDate}</span>
                <label>Hijri:</label>
                <span class="badge rounded-pill bg-info">{currentHijriDate}</span>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div className="customer-selection">
            <DynamicDropdown
              apiUrl="http://127.0.0.1:5000/api/customers"
              label="Customer"
              placeholder="Search customer..."
              value={selectedCustomer}
              onChange={handleCustomerChange}
              formatOption={(customer) => ({
                value: customer.code,
                label: customer.name,
              })}
            />
          </div>
          <div className="customer-details">
            {customerDetails && (
              <div>
                <div>
                  <span>Customer Code: {customerDetails.code}</span>
                </div>
                <div>
                  <span>Address: {customerDetails.address}</span>
                </div>
                <div>
                  <span>Phone: {customerDetails.phone}</span>
                </div>
              </div>
            )}
          </div>
            {customerDetails && (
              <div>
                <div>
                  <span>Customer Code: {customerDetails.code}</span>
                </div>
                <div>
                  <span>Address: {customerDetails.address}</span>
                </div>
                <div>
                  <span>Phone: {customerDetails.phone}</span>
                </div>
              </div>
            )}
    </header>
  );
};

export default BillingHeader;